var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col gap-y-2"},[_c('sidebar-dropdown-menu',{attrs:{"icon":"dolly","label":"Fournisseur"}},[_c('sidebar-nav-link-in-drop-down',{attrs:{"to":{name: 'suppliers.preview.list'}}},[_vm._v(" Précommandes ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }